// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__UZRX9","spin":"Loader_spin__nTmXf","popup":"Loader_popup__R92py","menu":"Loader_menu__Lmb5f","fadeIn":"Loader_fadeIn__c1ao1"};